import { dew as _UpdateFileRequestDew } from "./UpdateFileRequest";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.UpdateFileRequest = void 0;
  var UpdateFileRequest_1 = _UpdateFileRequestDew();
  Object.defineProperty(exports, "UpdateFileRequest", {
    enumerable: true,
    get: function () {
      return UpdateFileRequest_1.UpdateFileRequest;
    }
  });
  return exports;
}